export default "__VITE_ASSET__D$adC2MW__$_?url__"